<template>
  <b-card ref="contenedorCard">
    <div class="custom-container">
      <!-- banner bienvenida -->
      <img v-if="EmpresaId === 'CACCF73C-58B3-40F7-8C0E-EF211FA21D7F'
        || EmpresaId === 'caccf73c-58b3-40f7-8c0e-ef211fa21d7f'" src="/img/DentisaludLogos/logo%20400x400.png"
        alt="Logo empresa" class="logo" />
      <div class="row d-flex py-5 mb-5 rounded banner-content position-relative">
        <!-- arrow down scroll -->
        <div>
          <i class="fas fa-arrow-down fa-bounce position-absolute"
            style="bottom: -30px; left: 50%; font-size: 2rem"></i>
        </div>
        <!-- icons float -->
        <img class="position-absolute d-none d-lg-block" style="left: 50%; transform: rotate(30deg)"
          src="/img/undraw_alarm-clock.svg" alt="" />
        <img class="position-absolute d-none d-lg-block" style="right: 10%; opacity: 90%; transform: rotate(-10deg)"
          src="/img/undraw_pointer.svg" alt="" />
        <img class="position-absolute d-none d-lg-block" style="right: 35%; top: 40%; opacity: 50%"
          src="/img/undraw_code.svg" alt="" />
        <img class="position-absolute" style="left: 10%; bottom: 30%; opacity: 50%; transform: rotate(30deg)"
          src="/img/undraw_star.svg" alt="" />
        <img class="position-absolute d-none d-lg-block"
          style="width: 100px; bottom: 10%; left: 30%; transform: scaleX(-1)" src="/img/undraw_fun-arrow.svg" alt="" />
        <div class="col-12 col-lg">
          <div>
            <h1 class="display-4" style="font-weight: 700; margin-bottom: 1rem">
              ¡Empecemos a aprender,
              <span class="text-primary text-capitalize">{{
                `${persona.nombres} ${persona.apellidos}`
              }}</span>!
            </h1>
            <p class="h3">
              Destaca entre la multitud con las habilidades más actuales y únete
              a nuestra comunidad de aprendices apasionados. Juntos, podemos
              llegar lejos y lograr grandes cosas.
            </p>
          </div>
        </div>
        <div class="col mt-5 mt-lg-0">
          <img src="/img/undraw_online_learning_re_qw08.svg" alt="learning_img" />
        </div>
      </div>

      <!-- curso recomendado -->
      <div v-if="cursoRandom && cursoRandom.id">
        <div class="mb-3">
          <h1 class="mb-3">Qué aprender ahora</h1>
          <h3 class="myBorder">Nuestras principales sugerencias para ti</h3>
        </div>
        <b-card bg-variant="dark" class="border p-2 pointer custom-card" @click="
          $router.push(`/helex/Ayuda/Academia/InfoCurso/${cursoRandom?.id}`)
          ">
          <div class="d-flex row">
            <div class="col-12 col-lg-3 d-flex align-items-center">
              <ContenidoHelexium class="img-fluid w-100 rounded" :fileId="cursoRandom?.previewImagenUrl"
                :alt="cursoRandom?.titulo" :BotonDescargarArchivos="false" />
            </div>
            <div class="col-12 col-lg mt-3 mt-lg-0">
              <h2 class="font-weight-bold text-capitalize">
                {{ cursoRandom?.titulo }}
              </h2>
              <p class="h4 text-white-50 custom-text-truncate-p" style="line-height: 1.5">
                {{ cursoRandom?.descripcion }}
              </p>

              <div class="d-flex flex-column align-items-start flex-wrap">
                <div class="d-flex align-items-center">
                  <span class="custom-punto d-flex align-items-center font-weight-bold text-success my-2">
                    {{ cursoRandom?.categoriaCurso }}
                  </span>
                  <span class="custom-punto d-flex align-items-center text-capitalize">Por {{ cursoRandom?.responsable
                  }}</span>
                  <vs-tooltip>
                    <i :class="`fas fa-${!cursoRandom?.privacidad ? 'earth-americas' : 'lock'}`"></i>
                    <template #tooltip>{{ !cursoRandom?.privacidad ? "Curso público" : "Curso privado" }}
                    </template>
                  </vs-tooltip>
                </div>
                <div class="d-flex flex-wrap align-items-center">
                  <span class="custom-punto d-flex align-items-center">
                    <i class="fas fa-circle-check mr-1"></i> Última
                    actualización:
                    <span class="text-primary ml-1">
                      {{ cursoRandom?.ultimaActualizacion | formatLastUpdateDate }}</span>
                  </span>
                  <i class="fas fa-clock mr-1"></i>
                  <span class="text-white-50 custom-punto d-flex align-items-center">{{ cursoRandom?.duracion || 0 }}
                    min</span>
                  <i class="fas fa-play-circle mr-1"></i>
                  <span class="text-white-50">{{ cursoRandom?.clases || 0 }} {{ (cursoRandom?.clases || 0) > 1 ?
                    "clases" : "clase" }}</span>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </div>

      <!-- Tus Cursos -->
       
      <div v-if="cursosPersona.length > 0" class="my-5">
        <h3 class="myBorder">Tus cursos</h3>
        <div class="groupCard" id="GrupoCursosPersona" @scroll="handleScroll($event)">
          <vs-card class="custom-card-academia" v-for="curso in cursosPersona" :key="curso?.id"
            :id="`popover-${curso?.id}-persona`">
            <template #title>
              <div class="custom-text-truncate-title">
                <h3 class="text-capitalize">
                  {{ curso?.titulo }}
                </h3>
              </div>
            </template>
            <template #img>
              <ContenidoHelexium style="min-height: 162.89px; max-height: 162.89px; border-radius: 10px;"
                :fileId="curso?.previewImagenUrl" :alt="curso?.titulo" :BotonDescargarArchivos="false" />
            </template>
            <template #text>
              <div class="d-flex align-items-center text-white-50">
                <small class="custom-punto d-flex align-items-center text-capitalize">
                  Por {{ curso?.responsable }}
                </small>
                <vs-tooltip>
                  <i :class="`fas fa-${!curso?.privacidad ? 'earth-americas' : 'lock'}`"></i>
                  <template #tooltip>{{ !curso?.privacidad ? "Curso público" : "Curso privado" }}
                  </template>
                </vs-tooltip>
              </div>
              <small class="d-flex align-items-center text-white-50 mt-2">
                <i class="fas fa-circle-check mr-1"></i> Última actualización:
                <span class="text-primary ml-1">{{ curso?.ultimaActualizacion | formatLastUpdateDate }}</span>
              </small>
            </template>
            <template #interactions>
              <vs-button icon>
                <i class="far fa-clock mr-2"></i>
                <span class="span text-white">{{ curso?.duracion }} min</span>
              </vs-button>
              <vs-button class="btn-chat" dark icon>
                <i class="far fa-circle-play mr-2"></i>
                <span class="span">{{ curso?.clases }}</span>
              </vs-button>
              <vs-button class="btn-chat" success icon>
                <i class="fas fa-check-circle"></i>
              </vs-button>
            </template>
          </vs-card>
        </div>
        <b-popover v-for="curso in cursosPersona" :target="`popover-${curso?.id}-persona`" triggers="hover focus"
          :key="curso?.id">
          <template #title>
            <h3 class="custom-text-truncate-title text-capitalize">
              {{ curso?.titulo }}
            </h3>
          </template>
          <div class="d-flex justify-content-between my-2">
            <div class="d-flex align-items-center">
              <i class="fas fa-clock mr-1 text-warning" style="font-size: 14px"></i>
              <b style="font-size: 14px">{{ curso?.duracion }} min</b>
            </div>

            <div>
              <i class="fas fa-play-circle mr-1" style="font-size: 14px"></i>
              <b class="text-primary" style="font-size: 14px">{{ curso?.clases }}{{ curso?.clases > 1 ? " clases" :
                "clase" }}
              </b>
            </div>
          </div>
          <p class="custom-text-truncate-p text-white-50" style="font-size: 13px">
            {{ curso?.descripcion }}
          </p>
          <vs-button block :to="`/helex/Ayuda/Academia/AcademiaVideos/${curso?.id}`">
            <i class="fas fa-video mr-2"></i> Continua donde lo dejaste
          </vs-button>
        </b-popover>
      </div>

      <!-- cursos nuevos -->
      <div v-if="cursosRecientes.length > 0" class="my-5">
        <h3 class="myBorder">
          Cursos agregados recientemente
          <b-badge variant="info">Nuevos</b-badge>
        </h3>
        <div class="groupCard" id="GrupoCursosNuevos" @scroll="handleScroll($event)">
          <vs-card class="custom-card-academia" v-for="curso in cursosRecientes" :key="curso?.id"
            :id="`popover-${curso?.id}-recientes`">
            <template #title>
              <div class="custom-text-truncate-title">
                <h3 class="text-capitalize">{{ curso?.titulo }}</h3>
              </div>
            </template>
            <template #img>
              <ContenidoHelexium style="min-height: 162.89px; max-height: 162.89px; border-radius: 10px;"
                :fileId="curso?.previewImagenUrl" :alt="curso?.titulo" :BotonDescargarArchivos="false" />
            </template>
            <template #text>
              <div class="d-flex align-items-center text-white-50">
                <small class="custom-punto d-flex align-items-center text-capitalize">
                  Por {{ curso?.responsable }}
                </small>
                <vs-tooltip>
                  <i :class="`fas fa-${!curso?.privacidad ? 'earth-americas' : 'lock'}`"></i>
                  <template #tooltip>{{ !curso?.privacidad ? "Curso público" : "Curso privado" }}
                  </template>
                </vs-tooltip>
              </div>
              <small class="d-flex align-items-center text-white-50 mt-2">
                <i class="fas fa-circle-check mr-1"></i> Última actualización:
                <span class="text-primary ml-1">{{ curso?.ultimaActualizacion | formatLastUpdateDate }}</span>
              </small>
            </template>
            <template #interactions>
              <vs-button icon>
                <i class="far fa-clock mr-2"></i>
                <span class="span text-white">{{ curso?.duracion }} min</span>
              </vs-button>
              <vs-button class="btn-chat" dark icon>
                <i class="far fa-circle-play mr-2"></i>
                <span class="span">{{ curso?.clases }}</span>
              </vs-button>
              <vs-button v-if="curso?.seguimiento" class="btn-chat" success icon>
                <i class="fas fa-check-circle"></i>
              </vs-button>
            </template>
          </vs-card>
        </div>
        <b-popover v-for="curso in cursosRecientes" :target="`popover-${curso?.id}-recientes`" triggers="hover focus"
          :key="curso?.id">
          <template #title>
            <h3 class="custom-text-truncate-title text-capitalize">
              {{ curso?.titulo }}
            </h3>
          </template>
          <div class="d-flex justify-content-between my-2">
            <div class="d-flex align-items-center">
              <i class="fas fa-clock mr-1 text-warning" style="font-size: 14px"></i>
              <b style="font-size: 14px">{{ curso?.duracion }} min</b>
            </div>

            <div>
              <i class="fas fa-play-circle mr-1" style="font-size: 14px"></i>
              <b class="text-primary" style="font-size: 14px">{{ curso?.clases }}{{ curso?.clases > 1 ? " clases" :
                "clase" }}
              </b>
            </div>
          </div>
          <p class="custom-text-truncate-p text-white-50" style="font-size: 13px">
            {{ curso?.descripcion }}
          </p>
          <vs-button block :to="curso?.seguimiento ? `/helex/Ayuda/Academia/AcademiaVideos/${curso?.id}`
            : `/helex/Ayuda/Academia/InfoCurso/${curso?.id}`">
            <i class="fas fa-video mr-2"></i> {{ curso?.seguimiento ? "Continua donde lo dejaste" : "Ir a curso" }}
          </vs-button>
        </b-popover>
      </div>

      <!-- curso publicos -->
      <div v-if="cursosPublicos.length > 0" class="my-5">
        <h3 class="myBorder">Cursos públicos</h3>
        <div class="groupCard" id="GrupoCursosPublicos" @scroll="handleScroll($event)">
          <vs-card class="custom-card-academia" v-for="curso in cursosPublicos" :key="curso?.id"
            :id="`popover-${curso?.id}-public`">
            <template #title>
              <div class="custom-text-truncate-title">
                <h3 class="text-capitalize">
                  {{ curso?.titulo }}
                </h3>
              </div>
            </template>
            <template #img>
              <ContenidoHelexium style="min-height: 162.89px; max-height: 162.89px; border-radius: 10px;"
                :fileId="curso?.previewImagenUrl" :alt="curso?.titulo" :BotonDescargarArchivos="false" />
            </template>
            <template #text>
              <div class="d-flex align-items-center text-white-50">
                <small class="custom-punto d-flex align-items-center text-capitalize">
                  Por {{ curso?.responsable }}
                </small>
                <vs-tooltip>
                  <i :class="`fas fa-${!curso?.privacidad ? 'earth-americas' : 'lock'}`"></i>
                  <template #tooltip>{{ !curso?.privacidad ? "Curso público" : "Curso privado" }}
                  </template>
                </vs-tooltip>
              </div>
              <small class="d-flex align-items-center text-white-50 mt-2">
                <i class="fas fa-circle-check mr-1"></i> Última actualización:
                <span class="text-primary ml-1">{{ curso?.ultimaActualizacion | formatLastUpdateDate }}</span>
              </small>
            </template>
            <template #interactions>
              <vs-button icon>
                <i class="far fa-clock mr-2"></i>
                <span class="span text-white">{{ curso?.duracion }} min</span>
              </vs-button>
              <vs-button class="btn-chat" dark icon>
                <i class="far fa-circle-play mr-2"></i>
                <span class="span">{{ curso?.clases }}</span>
              </vs-button>
              <vs-button v-if="curso?.seguimiento" class="btn-chat" success icon>
                <i class="fas fa-check-circle"></i>
              </vs-button>
            </template>
          </vs-card>
        </div>
        <b-popover v-for="curso in cursosPublicos" :target="`popover-${curso?.id}-public`" triggers="hover focus"
          :key="curso?.id">
          <template #title>
            <h3 class="custom-text-truncate-title text-capitalize">
              {{ curso?.titulo }}
            </h3>
          </template>
          <div class="d-flex justify-content-between my-2">
            <div class="d-flex align-items-center">
              <i class="fas fa-clock mr-1 text-warning" style="font-size: 14px"></i>
              <b style="font-size: 14px">{{ curso?.duracion }} min</b>
            </div>

            <div>
              <i class="fas fa-play-circle mr-1" style="font-size: 14px"></i>
              <b class="text-primary" style="font-size: 14px">{{ curso?.clases }}{{ curso?.clases > 1 ? " clases" :
                "clase" }}
              </b>
            </div>
          </div>
          <p class="custom-text-truncate-p text-white-50" style="font-size: 13px">
            {{ curso?.descripcion }}
          </p>
          <vs-button block :to="curso?.seguimiento ? `/helex/Ayuda/Academia/AcademiaVideos/${curso?.id}`
            : `/helex/Ayuda/Academia/InfoCurso/${curso?.id}`">
            <i class="fas fa-video mr-2"></i> {{ curso?.seguimiento ? "Continua donde lo dejaste" : "Ir a curso" }}
          </vs-button>
        </b-popover>
      </div>

      <!-- curso privados -->
      <div v-if="cursosPrivados.length > 0" class="my-5">
        <h3 class="myBorder">Cursos privados</h3>
        <div class="groupCard" id="GrupoCursosPrivados" @scroll="handleScroll($event)">
          <vs-card class="custom-card-academia" v-for="curso in cursosPrivados" :key="curso?.id"
            :id="`popover-${curso?.id}-private`">
            <template #title>
              <div class="custom-text-truncate-title">
                <h3 class="text-capitalize">
                  {{ curso?.titulo }}
                </h3>
              </div>
            </template>
            <template #img>
              <ContenidoHelexium style="min-height: 162.89px; max-height: 162.89px; border-radius: 10px;"
                :fileId="curso?.previewImagenUrl" :alt="curso?.titulo" :BotonDescargarArchivos="false" />
            </template>
            <template #text>
              <div class="d-flex align-items-center text-white-50">
                <small class="custom-punto d-flex align-items-center text-capitalize">
                  Por {{ curso?.responsable }}
                </small>
                <vs-tooltip>
                  <i :class="`fas fa-${!curso?.privacidad ? 'earth-americas' : 'lock'}`"></i>
                  <template #tooltip>{{ !curso?.privacidad ? "Curso público" : "Curso privado" }}
                  </template>
                </vs-tooltip>
              </div>
              <small class="d-flex align-items-center text-white-50 mt-2">
                <i class="fas fa-circle-check mr-1"></i> Última actualización:
                <span class="text-primary ml-1">{{ curso?.ultimaActualizacion | formatLastUpdateDate }}</span>
              </small>
            </template>
            <template #interactions>
              <vs-button icon>
                <i class="far fa-clock mr-2"></i>
                <span class="span text-white">{{ curso?.duracion }} min</span>
              </vs-button>
              <vs-button class="btn-chat" dark icon>
                <i class="far fa-circle-play mr-2"></i>
                <span class="span">{{ curso?.clases }}</span>
              </vs-button>
              <vs-button v-if="curso?.seguimiento" class="btn-chat" success icon>
                <i class="fas fa-check-circle"></i>
              </vs-button>
            </template>
          </vs-card>
        </div>
        <b-popover v-for="curso in cursosPrivados" :target="`popover-${curso?.id}-private`" triggers="hover focus"
          :key="curso?.id">
          <template #title>
            <h3 class="custom-text-truncate-title text-capitalize">
              {{ curso?.titulo }}
            </h3>
          </template>
          <div class="d-flex justify-content-between my-2">
            <div class="d-flex align-items-center">
              <i class="fas fa-clock mr-1 text-warning" style="font-size: 14px"></i>
              <b style="font-size: 14px">{{ curso?.duracion }} min</b>
            </div>

            <div>
              <i class="fas fa-play-circle mr-1" style="font-size: 14px"></i>
              <b class="text-primary" style="font-size: 14px">{{ curso?.clases }}{{ curso?.clases > 1 ? " clases" :
                "clase" }}
              </b>
            </div>
          </div>
          <p class="custom-text-truncate-p text-white-50" style="font-size: 13px">
            {{ curso?.descripcion }}
          </p>
          <vs-button block :to="curso?.seguimiento ? `/helex/Ayuda/Academia/AcademiaVideos/${curso?.id}`
            : `/helex/Ayuda/Academia/InfoCurso/${curso?.id}`">
            <i class="fas fa-video mr-2"></i> {{ curso?.seguimiento ? "Continua donde lo dejaste" : "Ir a curso" }}
          </vs-button>
        </b-popover>
      </div>
      <!-- temas recomendados cursos -->
      <div v-if="listaCategorias.length > 0">
        <h3 class="mt-4 mb-3 myBorder">Temas recomendados para ti</h3>
        <b-tabs content-class="mt-3" class="custom-tabs" pills v-model="tabIndex">
          <b-tab v-for="(categoria, index) in listaCategorias" :title="categoria?.descripcion"
            :key="categoria?.descripcion" :active="index === 0" :title-link-class="linkClass(index)"
            @click="obtenerCursosCategoria(categoria?.id, categoria?.descripcion)">
            <div v-if="loadingCursosCategorias" class="groupCard" id="GrupoCursosLoad">
              <vs-card v-for="n in 3" :key="`skeleton-${n}`" class="custom-card-academia">
                <template #title>
                  <div class="skeleton skeleton-title"></div>
                </template>
                <template #img>
                  <div class="skeleton skeleton-image"></div>
                </template>
                <template #text>
                  <div class="skeleton skeleton-line"></div>
                  <div class="skeleton skeleton-line mt-2"></div>
                </template>
                <template #interactions>
                  <div class="skeleton skeleton-button"></div>
                </template>
              </vs-card>
            </div>
            <div v-else-if="cursosCategoria.length !== 0" class="groupCard" :id="`CtCr||${categoria?.descripcion}`"
              @scroll="handleScroll($event)">
              <vs-card class="custom-card-academia" v-for="curso in cursosCategoria" :key="curso?.id"
                :id="`popover-${curso?.id}-${categoria?.descripcion}`">
                <template #title>
                  <div class="custom-text-truncate-title">
                    <h3 class="text-capitalize">
                      {{ curso?.titulo }}
                    </h3>
                  </div>
                </template>
                <template #img>
                  <ContenidoHelexium style="min-height: 162.89px; max-height: 162.89px; border-radius: 10px;"
                    :fileId="curso?.previewImagenUrl" :BotonDescargarArchivos="false" :alt="curso?.titulo" />
                </template>
                <template #text>
                  <div class="d-flex align-items-center text-white-50">
                    <small class="custom-punto d-flex align-items-center text-capitalize">
                      Por {{ curso?.responsable }}
                    </small>
                    <vs-tooltip>
                      <i :class="`fas fa-${!curso?.privacidad ? 'earth-americas' : 'lock'}`"></i>
                      <template #tooltip>{{ !curso?.privacidad ? "Curso público" : "Curso privado" }}
                      </template>
                    </vs-tooltip>
                  </div>
                  <small class="d-flex align-items-center text-white-50 mt-2">
                    <i class="fas fa-circle-check mr-1"></i> Última
                    actualización:
                    <span class="text-primary ml-1">
                      {{ curso?.ultimaActualizacion | formatLastUpdateDate }}
                    </span>
                  </small>
                </template>
                <template #interactions>
                  <vs-button icon>
                    <i class="far fa-clock mr-2"></i>
                    <span class="span text-white">{{ curso?.duracion }} min</span>
                  </vs-button>
                  <vs-button class="btn-chat" dark icon>
                    <i class="far fa-circle-play mr-2"></i>
                    <span class="span">{{ curso?.clases }}</span>
                  </vs-button>
                  <vs-button v-if="curso?.seguimiento" class="btn-chat" success icon>
                    <i class="fas fa-check-circle"></i>
                  </vs-button>
                </template>
              </vs-card>
            </div>
            <div v-else class="text-center">
              <p class="font-weight-bold font-italic h3">No hay cursos que mostrar</p>
            </div>
            <b-popover v-for="curso in cursosCategoria" :target="`popover-${curso?.id}-${categoria?.descripcion}`"
              triggers="hover focus" :key="curso?.id">
              <template #title>
                <h3 class="custom-text-truncate-title text-capitalize">
                  {{ curso?.titulo }}
                </h3>
              </template>
              <div class="d-flex justify-content-between my-2">
                <div class="d-flex align-items-center">
                  <i class="fas fa-clock mr-1 text-warning" style="font-size: 14px"></i>
                  <b style="font-size: 14px">{{ curso?.duracion }} min</b>
                </div>
                <div>
                  <i class="fas fa-play-circle mr-1" style="font-size: 14px"></i>
                  <b class="text-primary" style="font-size: 14px">
                    {{ curso?.clases }}{{ curso?.clases > 1 ? " clases" : " clase" }}
                  </b>
                </div>
              </div>
              <p class="custom-text-truncate-p text-white-50" style="font-size: 13px">
                {{ curso?.descripcion }}
              </p>
              <vs-button block :to="curso?.seguimiento ? `/helex/Ayuda/Academia/AcademiaVideos/${curso?.id}`
                : `/helex/Ayuda/Academia/InfoCurso/${curso?.id}`">
                <i class="fas fa-video mr-2"></i> {{ curso?.seguimiento ? "Continua donde lo dejaste" : "Ir a curso" }}
              </vs-button>
            </b-popover>
          </b-tab>
        </b-tabs>
      </div>

      <!-- no hay cursos -->
      <div v-if="listaCursosAcademia.length === 0" class="text-center">
        <p class="font-weight-bold font-italic h3">No hay cursos que mostrar</p>
      </div>
    </div>
  </b-card>
</template>

<script>
import moment_timezone from "moment-timezone";
import { nextTick } from "vue";
import ContenidoHelexium from "../../../../components/helexium/ContenidoHelexium.vue";

export default {
  name: "Cursos",
  data() {
    return {
      persona: {},
      tabIndex: 0,
      EmpresaId: null,
      cursoRandom: null,
      cursosRecientes: [],
      cursosPublicos: [],
      cursosPrivados: [],
      cursosPersona: [],
      cursosCategoria: [],
      listaCursosAcademia: [],
      listaCategorias: [],
      loadingCursosCategorias: false,

      //Carga retrasada
      cantidadTarjetas: 0,

      Paginacion: 0,
      hasMore: {
        GrupoCursosPersona: true,
        GrupoCursosNuevos: true,
        GrupoCursosPublicos: true,
        GrupoCursosPrivados: true,
        // Para categorías, si es dinámico, se pueden agregar cuando sea necesario
      },
      isLoadingCurso: false,
    };
  },
  components: {
    ContenidoHelexium,
  },
  async mounted() {
    this.$isLoading(true);
    this.persona = JSON.parse(localStorage.getItem("setPersonaAct"));

    this.EmpresaId = this.persona.empresa.id;
    await nextTick();
    this.calcularTarjetasRecientes();
    window.addEventListener('resize', this.calcularTarjetasRecientes);
    this.$isLoading(false);
  },
  beforeUnmount() {
    // Removemos el listener para evitar fugas de memoria
    window.removeEventListener('resize', this.calcularTarjetasRecientes);
  },

  methods: {
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ["bg-danger", "text-light"];
      } else {
        return ["text-light"];
      }
    },
    async obtenerCursosCategoria(categoriaId, descripcion) {
      const group = "CtCr||" + descripcion;
      const existingKey = Object.keys(this.hasMore).find(key => key.startsWith("CtCr||"));
      if (existingKey) {
        // Si existe y no es el mismo que el que queremos, lo cambiamos
        if (existingKey !== group) {
          // Puedes eliminar la clave antigua y asignar la nueva
          this.$set(this.hasMore, group, true);
          delete this.hasMore[existingKey];
        }
      }
      else this.$set(this.hasMore, group, true);
      this.loadingCursosCategorias = true;
      try {
        const res = await this.$store.dispatch(
          "hl_get",
          {
            path: `CursosAcademia/ObtenerClasesPorCategoria/${categoriaId}/empresa/${this.EmpresaId}/persona/${this.persona.id}?cantidad=${this.cantidadTarjetas}`
          }
        );
        if (res.respuesta) {
          this.cursosCategoria = res.data;
        }
      } catch (error) {
        console.error("Error al obtener los cursos de la categoría:", error);
      } finally {
        this.loadingCursosCategorias = false; // Aquí usamos una función para que el valor se asigne correctamente
      }
    },
    async getListCursosAcademia() {
      this.$isLoading(true);
      try {
        const res = await this.$store.dispatch(
          "hl_get", { path: `CursosAcademia/ObtenerClases/${this.EmpresaId}/persona/${this.persona.id}?cantidad=${this.cantidadTarjetas}` }
        )
        if (res.respuesta) {
          this.listaCursosAcademia = res.data;

          this.cursoRandom = res.data.random[0];
          this.cursosPublicos = res.data.publicos;
          this.cursosPrivados = res.data.privados;
          this.cursosRecientes = res.data.recientes;
          this.cursosPersona = res.data.seguimiento;
          this.listaCategorias = res.data.categorias;
          this.cursosCategoria = res.data.CursosCategoria;

          const group = "CtCr||" + this.listaCategorias[0].descripcion;
          this.$set(this.hasMore, group, true);
        }
      } catch (error) {
        console.log("error capturado: ", error);
      } this.$isLoading(false);

    },
    calcularTarjetasRecientes() {
      const contenedorCard = this.$refs.contenedorCard;
      if (contenedorCard) {
        const visibleCards = Math.floor(contenedorCard.clientWidth / 250);
        this.cantidadTarjetas = visibleCards > 0 ? visibleCards + 1 : 5;
      } else {
        this.cantidadTarjetas = 10;
      }
      this.getListCursosAcademia()
    },
    handleScroll(event) {
      const container = event.target;
      const group = container.id;
      if (container.scrollLeft + container.clientWidth >= container.scrollWidth - 10 &&
        !this.isLoading && this.hasMore[group]) {
        this.loadCursos(group);
      }
    },
    async loadCursos(grupo) {
      console.log("Cargando cursos para el grupo:", grupo);

      const itemsPerLoad = this.cantidadTarjetas; // Por ejemplo, 8

      let currentCount = 0;
      if (grupo === "GrupoCursosPersona") {
        currentCount = this.cursosPersona.length;
      } else if (grupo === "GrupoCursosNuevos") {
        currentCount = this.cursosRecientes.length;
      } else if (grupo === "GrupoCursosPublicos") {
        currentCount = this.cursosPublicos.length;
      } else if (grupo === "GrupoCursosPrivados") {
        currentCount = this.cursosPrivados.length;
      } else if (grupo.startsWith("CtCr||")) {
        currentCount = this.cursosCategoria.length;
      }
      if (currentCount < itemsPerLoad) {
        return;
      }

      const nextPage = Math.floor(currentCount / itemsPerLoad) + 1;
      const url = `CursosAcademia/ObtenerClasesPaginadas/${this.EmpresaId}/persona/${this.persona.id}?cantidad=${itemsPerLoad}&paginacion=${nextPage}&tipo=${grupo}`;

      this.isLoading = true;
      try {
        const res = await this.$store.dispatch("hl_get", { path: url });
        if (res.respuesta) {
          const nuevosCursos = res.data; // Se espera que la API retorne un array con el lote correspondiente

          // Si la cantidad devuelta es menor que itemsPerLoad, significa que no hay más datos para cargar en este grupo
          if (nuevosCursos.length < itemsPerLoad) {
            this.hasMore[grupo] = false;
          }

          // Se concatena el nuevo lote al array correspondiente, según el grupo
          if (grupo === "GrupoCursosPersona") {
            this.cursosPersona = this.cursosPersona.concat(nuevosCursos);
          } else if (grupo === "GrupoCursosNuevos") {
            this.cursosRecientes = this.cursosRecientes.concat(nuevosCursos);
          } else if (grupo === "GrupoCursosPublicos") {
            this.cursosPublicos = this.cursosPublicos.concat(nuevosCursos);
          } else if (grupo === "GrupoCursosPrivados") {
            this.cursosPrivados = this.cursosPrivados.concat(nuevosCursos);
          } else if (grupo.startsWith("CtCr||")) {
            this.cursosCategoria = this.cursosCategoria.concat(nuevosCursos);
          }
        }
      } catch (error) {
        console.error("Error al cargar cursos para el grupo:", grupo, error);
      } finally {
        this.isLoading = false;
      }
    }

  },
  filters: {
    formatLastUpdateDate(fechaOriginal) {
      return moment_timezone
        .tz(fechaOriginal, "America/Bogota")
        .format("MMM D, YYYY");
    },
  },
};
</script>

<style scoped>
.groupCard {
  display: flex;
  flex-wrap: nowrap;
  overflow-y: auto;
  gap: 20px;
  margin-bottom: 25px;
  /* Ajuste del espacio inferior */
  padding-bottom: 20px;
  /* Espacio adicional dentro del contenedor */
  margin-top: 20px;
  padding-top: 20px;
}



.custom-card {
  opacity: 1;
  transition: opacity 1s ease 0s;
  background-color: #0f213f;
}

.custom-card:hover {
  opacity: 0.6;
}

.custom-text-truncate-p {
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}

.custom-text-truncate-title {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}

.myBorder {
  border-left: 2px solid #f0002b;
  padding-left: 0.5rem;
}

.skeleton {
  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
}

.skeleton-title {
  width: 80%;
  height: 20px;
}

.skeleton-image {
  width: 100%;
  height: 162.89px;
}

.skeleton-line {
  width: 90%;
  height: 16px;
}

.skeleton-button {
  width: 40%;
  height: 20px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}
</style>
